import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessGoalsIndexRoute extends Route {
  @service router;
  beforeModel() {
    this.router.transitionTo('business.goals.list');
  }
}

export default instrumentRoutePerformance(BusinessGoalsIndexRoute);
